import { render, staticRenderFns } from "./WalletOfDriver.vue?vue&type=template&id=03303350&"
import script from "./WalletOfDriver.vue?vue&type=script&lang=js&"
export * from "./WalletOfDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports